"use client";

import { useConnection, useReadContracts } from "wagmi";

import { ERC20_ABI } from "@/data/contracts/abis";
import type { TokenInfo } from "@/domain/types";

/** Every token's balanceOf for the connected wallet in ONE batch (wagmi
 * batches useReadContracts into a single Multicall3 call automatically,
 * same principle as the server-side multicall reads in data/). */
export function useTokenBalances(tokens: TokenInfo[]) {
  const { address } = useConnection();
  const { data, isLoading, refetch } = useReadContracts({
    contracts: address
      ? tokens.map((t) => ({ address: t.address, abi: ERC20_ABI, functionName: "balanceOf", args: [address] }) as const)
      : [],
    query: { enabled: Boolean(address && tokens.length > 0) },
  });

  const balances = new Map<string, bigint>();
  data?.forEach((r, i) => {
    const token = tokens[i];
    if (r.status === "success" && token) balances.set(token.address.toLowerCase(), r.result as bigint);
  });
  return { balances, isLoading, refetch };
}
